const isIdEnabledInTests = true;

export const getTestIdProps = (testId?: string) => {
  if (!testId) {
    return {};
  }
  const testIdProps = {
    'data-testid': testId,
  };

  return isIdEnabledInTests ? { ...testIdProps, id: testId } : testIdProps;
};
